import * as React from 'react'
import {
  ShardMetadata,
  CustomerAgencyShardMetadata,
  CustomerProductLine,
  ConnectorType,
} from 'api'
import { LoadingState } from './base'

export interface ShardsState {
  shards: ShardMetadata[]
  loadingState: LoadingState
}

export type ShardsAction = LoadShardsAction | ClearAction

export interface ShardsContextState {
  state: ShardsState
  dispatch: (action: ShardsAction) => void
}

type LoadShardsAction = {
  type: 'LoadShards'
  payload: ShardMetadata[]
  timestamp: number | null
}
type ClearAction = {
  type: 'Clear'
}

const DEFAULT_SHARDS_STATE: ShardsContextState = {
  state: {
    shards: [],
    loadingState: {
      status: 'None',
      lastApiReceiveAt: null,
    },
  } as ShardsState,
  dispatch: (action: ShardsAction) => {},
}

const reducer = (state: ShardsState, action: ShardsAction) => {
  switch (action.type) {
    case 'Clear': {
      return DEFAULT_SHARDS_STATE.state
    }
    case 'LoadShards': {
      return {
        ...state,
        shards: action.payload,
        loadingState: {
          status: 'None',
          lastApiReceiveAt: action.timestamp,
        },
      }
    }
  }
}

export const ShardsContext = React.createContext<ShardsContextState>(
  DEFAULT_SHARDS_STATE,
)

type ShardsContextProviderProps = {
  children: any
}

export const ShardsContextProvider: React.FunctionComponent<ShardsContextProviderProps> = ({
  children,
}) => {
  const [state, dispatch] = React.useReducer(
    reducer as React.Reducer<ShardsState, ShardsAction>,
    DEFAULT_SHARDS_STATE.state,
  )

  const value = { state, dispatch }

  return (
    <ShardsContext.Provider value={value}>{children}</ShardsContext.Provider>
  )
}

export const ShardsContextConsumer = ShardsContext.Consumer
